module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "f-footer mtp",
    class: {
      'f-back': _vm.currentType == 'login'
    },
    attrs: {
      "id": "mainfooter1"
    }
  }, [_c('div', {
    staticClass: "clearFix"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentType != 'login'),
      expression: "currentType != 'login'"
    }],
    staticClass: "footerTop wp",
    staticStyle: {
      "overflow": "inherit"
    }
  }, [_c('ul', [_c('li', {
    staticClass: "tLink"
  }, [_vm._v("在线预定")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.curlurl2 + 'about/appoint.html'
    }
  }, [_vm._v("定制流程")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.curlurl2 + 'about/pay.html'
    }
  }, [_vm._v("支付方式")])])]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "tLink"
  }, [_vm._v("消费保障")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.curlurl2 + 'about/service.html#q1'
    }
  }, [_vm._v("实名认证")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.curlurl2 + 'about/service.html#q2'
    }
  }, [_vm._v("定金担保")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.curlurl2 + 'about/service.html#q3'
    }
  }, [_vm._v("价格透明")])])]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "tLink"
  }, [_vm._v("售后服务")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.curlurl2 + 'about/aftersale.html#q1'
    }
  }, [_vm._v("无忧退款")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.curlurl2 + 'about/aftersale.html#q2'
    }
  }, [_vm._v("应急服务")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.curlurl2 + 'about/aftersale.html#q3'
    }
  }, [_vm._v("免费咨询")])])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "clearFix"
  }), _vm._v(" "), _c('div', {
    staticClass: "footerCenter wp",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_c('ul', {
    staticClass: "footerLink"
  }, [_c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.curlurl2 + 'about/about.html'
    }
  }, [_vm._v("关于找我")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.curlurl2 + 'about/contact.html'
    }
  }, [_vm._v("联系找我")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.curlurl2 + 'about/join.html'
    }
  }, [_vm._v("加入找我")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.curlurl2 + 'about/falv.html'
    }
  }, [_vm._v("法律声明")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.curlurl2
    }
  }, [_vm._v("快速定制")])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "u-Vline"
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "f-foot-icon"
  }, [_c('a', {
    staticClass: "foot-wx",
    on: {
      "mouseover": _vm.getBar,
      "mouseout": _vm.getBar
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.wxshow),
      expression: "wxshow"
    }],
    staticClass: "foot-gognzong"
  }), _vm._v(" "), _c('a', {
    staticClass: "foot-wb",
    attrs: {
      "target": "_blank",
      "href": "http://weibo.com/izhaowo"
    }
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "tLast"
  }, [_c('li', {
    staticClass: "title"
  }, [_vm._v("客服热线")]), _vm._v(" "), _c('li', {
    staticClass: "tCon"
  }, [_vm._v("4000-119-139")]), _vm._v(" "), _c('li', {
    staticClass: "tCon",
    staticStyle: {
      "font-size": "14px",
      "color": "#999"
    }
  }, [_vm._v("\n          周一至周日 9:00 - 18:30\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "width": "260px",
      "float": "left"
    }
  }, [_vm._v("\n        增值电信业务经营许可证："), _c('i', [_vm._v("川B2-20140181")]), _vm._v("   \n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "width": "250px",
      "display": "inline",
      "margin-left": "10px"
    }
  }, [_vm._v("\n           © 2014 izhaowo.com "), _c('i', [_vm._v("蜀ICP备14014073号")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27dabb82","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/foot-bar.vue
// module id = 82
// module chunks = 2 3 4 6 7